import { ByteWriter } from "hyparquet-writer";

export class OPFSFileWriter extends ByteWriter {
  public chunkSize = 1_000_000; // 1MB

  private closed = false;

  constructor(private handle: FileSystemSyncAccessHandle) {
    super();
  }

  public cancel() {
    if (this.closed === true) {
      return;
    }

    this.handle.truncate(0);
    this.handle.close();

    this.closed = true;
  }

  public ensure(size: number): void {
    if (this.index > this.chunkSize) {
      this.flush();
    }
    super.ensure(size);
  }

  public getBuffer(): never {
    throw new Error("getBuffer not supported for OPFSFileWriter");
  }

  public finish(): void {
    if (this.closed) {
      return;
    }
    this.flush();
    this.handle.close();
    this.closed = true;
  }

  public flush(): void {
    const chunk = this.buffer.slice(0, this.index);
    this.index = 0;
    if (chunk.byteLength === 0) {
      return;
    }
    this.handle.write(new DataView(chunk));
  }
}
